import css from "../../css/my-property/map.module.css";

import React from "react";
import PropTypes from "prop-types";

const Marker = (props) => {
    const { address, showAddress } = props;

    return (
        <div className={css.markerCirclet}>
            {showAddress && <div className={css.markerAddress}>{address}</div>}
        </div>
    );
};

Marker.propTypes = {
    address: PropTypes.string.isRequired,
    showAddress: PropTypes.bool.isRequired,
};

export default Marker;
